var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticStyle: { "margin-bottom": "40px", "text-align": "center" },
          attrs: { "align-h": "center" }
        },
        [
          _c("b-col", { attrs: { cols: "12", md: "4" } }, [
            _c("div", { ref: "paymentCheckout", staticClass: "payment" }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger btn-block mt-4",
                on: { click: _vm.cancelPayment }
              },
              [_vm._v("Cancel Transaction")]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9bc6700", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9bc6700","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Checkout.vue
// module id = null
// module chunks = 